const GUIDESAIL_ID = {
  dashboard: {
    en: 'nub3',
    ar: 'lhib',
  },
  order_list: {
    en: '0yXJ',
    ar: 'SX88',
  },
  order_detail: {
    en: '',
    ar: '',
  },
  dispute_list: {
    en: 'qtc3',
    ar: '',
  },
  dispute_detail: {
    en: '',
    ar: '',
  },
  settlement_information: {
    en: 'KZPG',
    ar: 'jRKP',
  },
  invoice_list: {
    en: '',
    ar: '',
  },
  export_list: {
    en: '',
    ar: '',
  },
  user_list: {
    en: '3jbw',
    ar: '6H39',
  },
  user_detail: {
    en: 'Vezl',
    ar: '1mWZ',
  },
  user_add_new: {
    en: 'X8AK',
    ar: 'NiP0',
  },
  role_list: {
    en: '',
    ar: '',
  },
  role_detail: {
    en: '',
    ar: '',
  },
  setting_store_list: {
    en: '',
    ar: '',
  },
}

export { GUIDESAIL_ID }
